import { request } from '@umijs/max';

export type MaintenanceConfig = {
  enabled: boolean;
  title: string;
  message: string;
};

export async function getMaintenanceConfig() {
  return request<MaintenanceConfig>('/maintenance', {
    method: 'GET',
  });
}
